/* eslint-disable react/prop-types */
import React from "react";

/**
 * Text logo used in Sidebar and landing (Navbar, Footer).
 * LEADZ (emerald) + LAB (slate), with optional group-hover on LEADZ.
 */
function Logo({ className = "" }) {
  return (
    <span className={`inline-flex items-baseline font-bold tracking-tight ${className}`}>
      <span className="text-emerald-600 group-hover:text-emerald-700 transition-colors">LEADZ</span>
      <span className="text-slate-800">LAB</span>
    </span>
  );
}

export default Logo;
